import React from "react"
import { Field, useFormState } from "react-final-form"

import { Grid } from "@mui/material"

import { FilterGroup } from "./layout"
import { LabeledRadio } from "../../../atoms"

export const RadioFilter = ({ items, name, title, key = name, defaultValue = null }) => {
  const valueFromStore = useFormState().values?.[name]

  return (
    <FilterGroup xs={12} groupTitle={title}>
      <Grid container justifyContent="start" spacing={1}>
        {items?.map(({ label, value }) => (
          <Grid item xs={4} key={`li${value}${key}`}>
            <Field
              name={name}
              type="radio"
              value={value}
              initialValue={valueFromStore || defaultValue || items[0].value}>
              {({ input }) => (
                <LabeledRadio {...input} checked={input.checked} color={"primary"} label={label} />
              )}
            </Field>
          </Grid>
        ))}
      </Grid>
    </FilterGroup>
  )
}
